import { GW4BleMessage } from "./gw4BleMessage";

export const GW4BLEOutgoingMessageType = 0x0600;

export class GW4BleOutgoingMessage extends GW4BleMessage {
  constructor(serialNumber: number) {
    super(serialNumber, GW4BLEOutgoingMessageType);
  }
}
